var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"additive-widget pt-0"},[_c('div',{class:[
      'form-wrapper my-4',
      _vm.showForm ? 'w-full' : 'hide-additive-form'
    ]},[_c('span',{staticClass:"empty-text mb-4"},[_vm._v("No "+_vm._s(_vm.label)+" have been added")]),_c('vue-form-generator',{ref:"additiveForm",staticClass:"w-full p-0",attrs:{"model":_vm.value,"options":_vm.formOptions,"schema":_vm.localSchema}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }